export default {
    'tel': /^1([38][0-9]|4[579]|5[0-3,5-9]|6[6]|7[0135678]|9[89])\d{8}$/,
    'username': /^[a-zA-Z0-9]{6,}$/,
    'password': /^[A-Za-z0-9]{6,20}$/,
    'idcard': /^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$|^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}([0-9]|X)$/,
    'positiveInt': /^[1-9]\d*$/, // 正整数
}